export default __webpack_public_path__ + "static/media/misc-books4-1920w.0e6f4c9f.webp";